import React from 'react';
import Navbar from '../../Shared/Navbar/Navbar';

const About = () => {
    return (
        <div>
            <Navbar></Navbar>
            <h1>I am from About Page</h1>
        </div>
    );
};

export default About;